import * as React from 'react';

import loginRoutes from './components/login/Login.Routes';
import mainRoutes from './components/main/Main.Routes';
import adminRoutes from './components/admin/Admin.Routes';
import clientRoutes from './components/clients/Client.Routes';
import companyRoutes from './components/companies/Company.Routes';
import contactRoutes from './components/contacts/Contact.Routes';
import profileRoutes from './components/profile/Profile.Routes';
import timeRoutes from './components/time/TimeExpense.Routes';
import projectRoutes from './components/project/Project.Routes';
import landmenRoutes from './components/personnel/Personnel.Routes';
import apRoutes from './components/accounts-payable/AP.Routes';
import gisRoutes from './components/gis/GIS.Routes';
// import invoicingRoutes from './components/invoicing/Invoicing.Routes';

import NotFound from './components/common/NotFoundPage';
import SecondWindow from './components/common/SecondWindow';
import FormDoc from 'src/components/FormPoc/Document';
import FormPoc from 'src/components/FormPoc/Form';

import { Route } from 'react-router-dom';
import LeaseDocument from './components/project/sections/LeasingComponents/LeaseDocument';

export default function getRouter(isLoggedIn: boolean, isAdmin: boolean) {
    const allRoutes = [
        ...mainRoutes(isLoggedIn),
        ...adminRoutes(isLoggedIn, true),
        ...loginRoutes(isLoggedIn),
        ...projectRoutes(isLoggedIn),
        ...clientRoutes(isLoggedIn),
        ...companyRoutes(isLoggedIn),
        ...contactRoutes(isLoggedIn),
        ...profileRoutes(isLoggedIn),
        ...timeRoutes(isLoggedIn),
        ...landmenRoutes(isLoggedIn),
        ...apRoutes(isLoggedIn),
        ...gisRoutes(isLoggedIn),
        // ...invoicingRoutes(isLoggedIn),
        <Route key="second-window" path="/second-window" component={SecondWindow} />,
        <Route key="formpoc" path="/formpoc" component={FormPoc} />,
        <Route key="formdoc" path="/formdoc" component={FormDoc} />,
        <Route key="leasedoc" path="/lease-form" component={LeaseDocument} />,
        <Route key="not-found" component={NotFound} />,
    ];

    return allRoutes;
}



// WEBPACK FOOTER //
// ./src/routes.tsx